import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { Message } from 'primeng/components/common/api';
import { RegistrationService } from '../../services/registration.service';

@Component({
  selector: 'app-admissionfeespayment',
  templateUrl: './admissionfeespayment.component.html',
  styleUrls: ['./admissionfeespayment.component.scss']
})
export class AdmissionfeespaymentComponent implements OnInit {
  msgs: Message[] = [];
  cdid: any;
  amount: any;
  datalist: any;
  admitsLink: any;
  display = false;
  forpayment: boolean = false;
  INDUSTRY_TYPE_ID: any;
  CHANNEL_ID: any;
  MID: any;
  CALLBACK_URL: any;
  WEBSITE: any;
  MERC_UNQ_REF: any;
  ORDER_ID: any;
  CUST_ID: any;
  MOBILE_NO: any;
  EMAIL: any;
  REQUEST_TYPE: any;
  TXN_AMOUNT: any;
  CHECKSUMHASH: any;
  VERIFIED_BY: any;
  dataList1: any;
  tableData: any = [];
  @ViewChild('form') form: ElementRef;

  //************ Below variable decleare for HDFC Payment *************
  // fname:any;
  // lname:any;
  // phone:any;
  // return_url:any;
  // key:any;
  // secure_hash:any;
  // txnid:any;
  // description:any;
  // amount_txn_hdfc:any;
  // email:any;
  // udf1:any;
  // udf2:any;
  // udf3:any;
  // udf4:any;
  // udf5:any;
  // @ViewChild('formhdfc') formhdfc: ElementRef;
  //End

  //************ Below variable decleare for ICICI Payment *************
  encRequest: any;
  access_code: any;
  merchant_id: any;
  enc_key: any;
  order_id: any;
  currency: any;
  amount_icici: any;
  redirect_url: any;
  cancel_url: any;
  language: any;
  udf1: any;
  udf2: any;
  udf3: any;
  udf4: any;
  udf5: any;
  @ViewChild('formicici') formicici: ElementRef;

  //************ Below variable decleare for Federal Online Payment *************

  merchantRequest: any;
  mid: any;
  checkout: any;
  federaludf1: any;
  federaludf2: any;
  federaludf3: any;
  federaludf4: any;
  federaludf5: any;
  @ViewChild('formfederal') formfederal: ElementRef;

  constructor(private router: Router, private spinner: NgxSpinnerService, private registrationService: RegistrationService,) { }

  ngOnInit() {
    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'Please Note :' });
    this.msgs.push({ severity: 'info', summary: '1.  Choose between Online Payment or Cash Payment at Federal Bank.' });
    this.msgs.push({ severity: 'info', summary: '2.  Do not press F5, Refresh, Reload, Right-click, or Backspace during online payment.' });
    this.msgs.push({ severity: 'info', summary: '3.  After successful payment, click on "Click here to Print Admission Fees Paid Challan" for receipt. In case of online payment, bank stamp is not required.' });
    this.msgs.push({ severity: 'info', summary: '4.  If your challan lacks an E-paid stamp even after deduction of amount while making Online payment,<a href="https://docs.google.com/forms/d/e/1FAIpQLSc3IGIEJ3NYFKkX2fsShfOhPIynJranHqvk-EqwYtEW3uabOw/viewform?pli=1" target="_blank"> Click here to notify us through Google form.</a>' });
    this.msgs.push({ severity: 'info', summary: '5.  <strong><font color="red">Cheque/D.D./RTGS/NEFT payments are not accepted and shall not be considered valid.</font></strong>' });
    this.msgs.push({ severity: 'info', summary: '6.  For cash payments, select "Cash Payment at Federal Bank" to generate and download the payment challan. Visit any Federal Bank branch with the printout of the generated challan. <a href="https://www.federal.bank.in/atm-branch-locator" target="_blank"> View Kolkata branches here.</a>' });
    this.msgs.push({ severity: 'info', summary: '7.  If you can\'t generate the challan, check if your browser\'s pop-up is blocked (<strong><font color="red">look for a red cross on the top right</font></strong>), click on it to enable the popup, then try to generate the challan.' });
    this.cdid = localStorage.getItem("cdid");
    // console.log(this.cdid + "cdid");
    this.getAdmissionFees();
  }

  ngAfterViewInit() {
    (document.querySelector('.layout-wrapper .layout-content .layout-content-container') as HTMLElement).style.marginTop = '200px';
  }
  ngOnDestroy() {
    (document.querySelector('.layout-wrapper .layout-content .layout-content-container') as HTMLElement).style.marginTop = '10px';
  }

  getAdmissionFees() {
    this.spinner.show();
    this.registrationService.getAdmissionFess(localStorage.getItem('authToken'), this.cdid)
      .then(res => {
        // console.log(res);
        this.spinner.hide();
        if (res.status === 'success') {
          this.amount = res.totamt;
        }
      });
  }


  goToDashboard() {
    this.router.navigate(['candidate/dashboard']);
  }

  // payment() {
  //   this.spinner.show();
  // if(((<HTMLInputElement>document.getElementById('pamentType')).value) == 'Online Payment'){
  //   alert("Online Payment will start from 12/06/2019");
  //   this.spinner.hide();
  //   return false;
  // }
  // this.registrationService.submitAdmissionPayment(localStorage.getItem('authToken'),this.cdid,(<HTMLInputElement>document.getElementById('pamentType')).value).subscribe(
  //   data => {
  //     // console.log(data);
  //     this.datalist = data;
  //     this.spinner.hide();
  //     if(this.datalist.status === 'success'){

  //       //window.open(this.datalist.payurl,"_self");
  //       this.forpayment = true;

  //       this.INDUSTRY_TYPE_ID= this.datalist.INDUSTRY_TYPE_ID;
  //       this.CHANNEL_ID= this.datalist.CHANNEL_ID;
  //       this.MID= this.datalist.MID;
  //       this.CALLBACK_URL= this.datalist.CALLBACK_URL;
  //   this.WEBSITE= this.datalist.WEBSITE;
  //   this.MERC_UNQ_REF= this.datalist.MERC_UNQ_REF;
  //   this.ORDER_ID= this.datalist.ORDER_ID;
  //   this.CUST_ID= this.datalist.CUST_ID;
  //   this.MOBILE_NO= this.datalist.MOBILE_NO;
  //   this.EMAIL= this.datalist.EMAIL;
  //   this.REQUEST_TYPE= this.datalist.REQUEST_TYPE;
  //   this.TXN_AMOUNT= this.datalist.TXN_AMOUNT;
  //   this.CHECKSUMHASH= this.datalist.CHECKSUMHASH;
  //   this.VERIFIED_BY= this.datalist.VERIFIED_BY;

  //   setTimeout(() => {
  //     this.spinner.hide();
  //     this.pay()
  //   }, 2000);
  // }
  //       else{
  //         //this.tableData = this.datalist.challanLink;
  //         this.admitsLink = this.datalist.webLink;
  //         if (this.admitsLink !== '') {
  //           this.spinner.hide();
  //           this.display = true;
  //         }
  //       }
  //     },err =>{
  //       this.spinner.hide();
  //     })
  //   //this.display = true;
  // }

  payment() {
    this.spinner.show();
    //alert((<HTMLInputElement>document.getElementById('pamentType')).value);
    var pType = (<HTMLInputElement>document.getElementById('pamentType')).value;
    // console.log(pType,this.cdid,localStorage.getItem('authToken'));
    if (pType == 'Paynimo') {
      this.registrationService.payPaynimoAdm(this.cdid, localStorage.getItem('authToken'));
    }

    else {
      this.registrationService.submitAdmissionPayment(localStorage.getItem('authToken'), this.cdid, pType).subscribe(
        data => {
          this.dataList1 = data;
          // console.log(this.dataList1)
          //------ add for ICICI ------
          if (this.dataList1.status === 'success' && pType === 'Online PaymentI') {
            this.forpayment = true;

            this.encRequest = this.dataList1.encRequest;
            this.access_code = this.dataList1.access_code;
            this.merchant_id = this.dataList1.merchant_id;
            this.enc_key = this.dataList1.enc_key;
            this.order_id = this.dataList1.order_id;
            this.currency = this.dataList1.currency;
            this.amount_icici = this.dataList1.amount;
            this.redirect_url = this.dataList1.redirect_url;
            this.cancel_url = this.dataList1.cancel_url;
            this.language = this.dataList1.language;
            this.udf1 = this.dataList1.udf1;
            this.udf2 = this.dataList1.udf2;
            this.udf3 = this.dataList1.udf3;
            this.udf4 = this.dataList1.udf4;
            this.udf5 = this.dataList1.udf5;

            setTimeout(() => {
              this.spinner.hide();
              this.pay('icici')
            }, 2000);
          }
          else if (this.dataList1.status === 'success' && pType === 'Online PaymentP') {
            this.forpayment = true;

            this.INDUSTRY_TYPE_ID = this.dataList1.INDUSTRY_TYPE_ID;
            this.CHANNEL_ID = this.dataList1.CHANNEL_ID;
            this.MID = this.dataList1.MID;
            this.CALLBACK_URL = this.dataList1.CALLBACK_URL;
            this.WEBSITE = this.dataList1.WEBSITE;
            this.MERC_UNQ_REF = this.dataList1.MERC_UNQ_REF;
            this.ORDER_ID = this.dataList1.ORDER_ID;
            this.CUST_ID = this.dataList1.CUST_ID;
            this.MOBILE_NO = this.dataList1.MOBILE_NO;
            this.EMAIL = this.dataList1.EMAIL;
            this.REQUEST_TYPE = this.dataList1.REQUEST_TYPE;
            this.TXN_AMOUNT = this.dataList1.TXN_AMOUNT;
            this.CHECKSUMHASH = this.dataList1.CHECKSUMHASH;
            this.VERIFIED_BY = this.dataList1.VERIFIED_BY;
            setTimeout(() => {
              this.spinner.hide();
              this.pay('paytm')
            }, 2000);
          }
          else if (this.dataList1.status === 'success' && pType === "Online PaymentF") {
            this.forpayment = true;

            this.merchantRequest = this.dataList1.merchantRequest;
            this.mid = this.dataList1.mid;
            // this.checkout = this.dataList1.checkout;
            this.federaludf1 = this.dataList1.udf1;
            this.federaludf2 = this.dataList1.udf2;
            this.federaludf3 = this.dataList1.udf3;
            this.federaludf4 = this.dataList1.udf4;
            this.federaludf5 = this.dataList1.udf5;

            setTimeout(() => {
              this.spinner.hide();
              this.pay('federal')
            }, 2000);
            //window.open(this.dataList1.payurl,'mywin','left=20,top=20,width=500,height=500,toolbar=1,resizable=0');
            //window.open(this.dataList1.payurl,"_self");
            // } else if(this.dataList1.status === 'success' && pType === 'Online PaymentH'){
            //     this.forpayment = true;

            //     this.fname = this.dataList1.fname;
            //     this.lname = this.dataList1.lname;
            //     this.phone = this.dataList1.phone;
            //     this.return_url = this.dataList1.return_url;
            //     this.key = this.dataList1.key;
            //     this.secure_hash = this.dataList1.secure_hash;
            //     this.txnid = this.dataList1.txnid;
            //     this.description = this.dataList1.description;
            //     this.amount_txn_hdfc = this.dataList1.amount;
            //     this.email = this.dataList1.email;
            //     this.udf1 = this.dataList1.udf1;
            //     this.udf2 = this.dataList1.udf2;
            //     this.udf3 = this.dataList1.udf3;
            //     this.udf4 = this.dataList1.udf4;
            //     this.udf5 = this.dataList1.udf5;

            //     setTimeout(() => {
            //       this.spinner.hide();
            //       this.pay('hdfc')
            //     }, 2000);
          } else {
            const name = this.dataList1.name;
            const emlbody = this.dataList1.emlbody;
            const emlpw = this.dataList1.emlpw;
            const emlsendto = this.dataList1.emlsendto;
            const emlsub = this.dataList1.emlsub;
            const emlun = this.dataList1.emlun
            this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
              // console.log('SMS sent successfully:', response);
            })
              .catch(error => {
                alert(error.message);
              });

            this.tableData = this.dataList1.challanLink;
            this.admitsLink = this.dataList1.webLink;
            if (this.admitsLink !== '') {
              this.spinner.hide();
              this.display = true;
            }
          }
        }
        , error => {
          alert('Something went wrong. Please try again')
          this.spinner.hide();
        }
      );
      //this.display = true;
    }
  }

  pay(v: any) {
    if (v === 'paytm') {
      this.form.nativeElement.submit();
    }
    // else if (v === 'icici') {
    //   this.formicici.nativeElement.submit();
    // }
    else {
      this.formfederal.nativeElement.submit();
    }
    // else {
    //   this.formhdfc.nativeElement.submit();
    // }
  }

  // pay() {
  // 	this.form.nativeElement.submit();
  // }

  onSelectFedBankOnline(e) {
    var payType = (<HTMLInputElement>document.getElementById('pamentType')).value;
    if (payType == "Online PaymentF") {
      alert("The Federal Bank payment gateway is temporarily unavailable due to maintenance activity. Inconvenience caused is regretted.");
      e.target.value = "Online PaymentP";
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/candidate/admissionfeespayment/admissionfeespayment.component.ts